import {createHowl} from 'utils/playSound';

import no_introSound from 'assets/sounds/no/intros/pd-intro.mp3';
import no_gris from 'assets/sounds/no/phonemeDeletion/gris.mp3';
import no_ris from 'assets/sounds/no/phonemeDeletion/gris-g.mp3';
import no_foere from 'assets/sounds/no/phonemeDeletion/foere.mp3';
import no_oere from 'assets/sounds/no/phonemeDeletion/foere-f.mp3';
import no_sel from 'assets/sounds/no/phonemeDeletion/sel.mp3';
import no_se from 'assets/sounds/no/phonemeDeletion/sel-l.mp3';
import no_gaas from 'assets/sounds/no/phonemeDeletion/gaas-g.mp3';
import no_maal from 'assets/sounds/no/phonemeDeletion/maal-m.mp3';
import no_broed from 'assets/sounds/no/phonemeDeletion/broed-b.mp3';
import no_klaer from 'assets/sounds/no/phonemeDeletion/klaer-k.mp3';
import no_brev from 'assets/sounds/no/phonemeDeletion/brev-b.mp3';
import no_trygg from 'assets/sounds/no/phonemeDeletion/trygg-t.mp3';
import no_drap from 'assets/sounds/no/phonemeDeletion/drap-d.mp3';
import no_skyll from 'assets/sounds/no/phonemeDeletion/skyll-l.mp3';
import no_laas from 'assets/sounds/no/phonemeDeletion/laas-s.mp3';
import no_bro from 'assets/sounds/no/phonemeDeletion/bro-r.mp3';
import no_klatre from 'assets/sounds/no/phonemeDeletion/klatre-t.mp3';
import no_malt from 'assets/sounds/no/phonemeDeletion/malt-l.mp3';
import no_bry from 'assets/sounds/no/phonemeDeletion/bry-r.mp3';
import no_lekse from 'assets/sounds/no/phonemeDeletion/lekse-k.mp3';
import no_sport from 'assets/sounds/no/phonemeDeletion/sport-p.mp3';
import no_loff from 'assets/sounds/no/phonemeDeletion/loff-f.mp3';

import nn_introSound from 'assets/sounds/nn/intros/pd-intro.mp3';
import nn_gris from 'assets/sounds/nn/phonemeDeletion/gris.mp3';
import nn_ris from 'assets/sounds/nn/phonemeDeletion/gris-g.mp3';
import nn_foere from 'assets/sounds/nn/phonemeDeletion/foere.mp3';
import nn_oere from 'assets/sounds/nn/phonemeDeletion/foere-f.mp3';
import nn_sel from 'assets/sounds/nn/phonemeDeletion/sel.mp3';
import nn_se from 'assets/sounds/nn/phonemeDeletion/sel-l.mp3';
import nn_gaas from 'assets/sounds/nn/phonemeDeletion/gaas-g.mp3';
import nn_maal from 'assets/sounds/nn/phonemeDeletion/maal-m.mp3';
import nn_broed from 'assets/sounds/nn/phonemeDeletion/broed-b.mp3';
import nn_klede from 'assets/sounds/nn/phonemeDeletion/klede-k.mp3';
import nn_brev from 'assets/sounds/nn/phonemeDeletion/brev-b.mp3';
import nn_trygg from 'assets/sounds/nn/phonemeDeletion/trygg-t.mp3';
import nn_drap from 'assets/sounds/nn/phonemeDeletion/drap-d.mp3';
import nn_skyl from 'assets/sounds/nn/phonemeDeletion/skyl-l.mp3';
import nn_laas from 'assets/sounds/nn/phonemeDeletion/laas-s.mp3';
import nn_bro from 'assets/sounds/nn/phonemeDeletion/bru-r.mp3';
import nn_klatre from 'assets/sounds/nn/phonemeDeletion/klatre-t.mp3';
import nn_malt from 'assets/sounds/nn/phonemeDeletion/malt-l.mp3';
import nn_bry from 'assets/sounds/nn/phonemeDeletion/bry-r.mp3';
import nn_lekse from 'assets/sounds/nn/phonemeDeletion/lekse-k.mp3';
import nn_sport from 'assets/sounds/nn/phonemeDeletion/sport-p.mp3';
import nn_loff from 'assets/sounds/nn/phonemeDeletion/loff-f.mp3';

export const no_intro = {
	intro: no_introSound,
	task1: no_gris,
	task1a: no_ris,
};

export const nn_intro = {
	intro: nn_introSound,
	task1: nn_gris,
	task1a: nn_ris,
};

export const no_test = [
	createHowl({src: no_gaas}),
	createHowl({src: no_maal}),
	createHowl({src: no_broed}),
	createHowl({src: no_klaer}),
	createHowl({src: no_brev}),
	createHowl({src: no_trygg}),
	createHowl({src: no_drap}),
	createHowl({src: no_loff}),
	createHowl({src: no_skyll}),
	createHowl({src: no_laas}),
	createHowl({src: no_bro}),
	createHowl({src: no_klatre}),
	createHowl({src: no_malt}),
	createHowl({src: no_bry}),
	createHowl({src: no_lekse}),
	createHowl({src: no_sport}),
];

export const nn_test = [
	createHowl({src: nn_gaas}),
	createHowl({src: nn_maal}),
	createHowl({src: nn_broed}),
	createHowl({src: nn_klede}),
	createHowl({src: nn_brev}),
	createHowl({src: nn_trygg}),
	createHowl({src: nn_drap}),
	createHowl({src: nn_loff}),
	createHowl({src: nn_skyl}),
	createHowl({src: nn_laas}),
	createHowl({src: nn_bro}),
	createHowl({src: nn_klatre}),
	createHowl({src: nn_malt}),
	createHowl({src: nn_bry}),
	createHowl({src: nn_lekse}),
	createHowl({src: nn_sport}),
];
